<template>
  <div>
    <div class="title">卡片详情</div>
    <van-field
      v-model="chinese_name"
      type="text"
      label="中文姓名"
      :label-width="100"
      readonly
    />
    <van-field
      v-model="name"
      type="text"
      label="英文姓名"
      :label-width="100"
      readonly
    />
    <van-field
      v-model="mobile"
      type="text"
      label="手机号"
      :label-width="100"
      readonly
    />
    <van-field
      v-model="currency"
      type="text"
      label="币种"
      :label-width="100"
      readonly
    />
    <van-field
      v-model="card_name"
      type="text"
      label="卡片"
      :label-width="100"
      readonly
    />
    <van-field
      v-model="card_no"
      type="text"
      label="卡号"
      :label-width="100"
      readonly
    />
    <van-field
      v-model="address"
      type="textarea"
      label="地址"
      :label-width="100"
      readonly
    />
    <van-field
      v-model="created_at"
      type="text"
      label="创建时间"
      :label-width="100"
      readonly
    />
    <van-field
      v-model="statusTxt"
      type="text"
      label="状态"
      :label-width="100"
      readonly
    />
  </div>
</template>
<script>
  export default {
		name: 'personal_step7',
		data() {
			return {
        step:0,
				name:'',
				mobile:'',
				currency:'',
				card_name:'',
				address:'',
				card_no:'',
				created_at:'',
				chinese_name:'',
        status:'',
        statusTxt:''
			}
		},
		mounted() {
			if (this.$route.query.token == "" || this.$route.query.token == undefined) {
				this.$router.replace('/nologin')
			}
      this.getProtocol()
			this.getNewest()
		},
		methods: {
			getProtocol(){
        this.$axios({
					method: 'post',
					url: 'speedpay_user/index', 
					data: {
            token: this.$route.query.token,
            card_type:this.$route.query.card_type
          }
				}).then ((res) => {
					if (res.success) {
            this.step=res.data.step;
            this.kycEnable=res.data.kycEnable;
            this.kycAddEnable=res.data.kycAddEnable;
            this.msg=res.data.msg;
            // if(this.step==2){
            //   this.$router.push('/speedpay/papers?token='+this.$route.query.token +'&card_type='+this.$route.query.card_type)
            // }else if(this.step==3){
            //   this.$router.push('/speedpay/step3?token='+this.$route.query.token +'&card_type='+this.$route.query.card_type)
            // }else if(this.step==4){
            //   this.$router.push('/speedpay/step4?token='+this.$route.query.token +'&card_type='+this.$route.query.card_type)
            // }
            // else if(this.step==5){
            //   this.$router.push('/speedpay/step5?token='+this.$route.query.token +'&card_type='+this.$route.query.card_type)
            // }
            // else if(this.step==6){
            //   this.$router.push('/speedpay/step6?token='+this.$route.query.token +'&card_type='+this.$route.query.card_type)
            // }
					}else {
						this.$dialog.alert({
							message: res.error_text
						})
					}
				})
      },
      getNewest(){
				this.$axios({
					method: 'post',
					url: 'speedpay_card/newest',
					data: {
						token:this.$route.query.token,
            card_type:this.$route.query.card_type
					}
				}).then ((res) => {
					if (res.success) {
            console.log(res)
            this.name = res.data.name
            this.mobile = res.data.mobile
            this.currency = res.data.currency
            this.card_name = res.data.card_name
            this.address = res.data.address
            this.card_no = res.data.card_no
            this.created_at = res.data.created_at
            this.chinese_name = res.data.chinese_name
            this.status = res.data.status
            this.statusZh(this.status)
					}else {
						this.$dialog.alert({
							message: res.error_text
						})
					}
				})
			},
      // status：1: 审核中，2: 审核通过，3：已发卡，4：已激活，5： 已实名，9：被驳回，10：已取消
      statusZh(status){
        console.log(status)
        switch (status) {
          case '1':
            this.statusTxt = '审核中'
            break;
          case '2':
            this.statusTxt = '审核通过'
            break;
          case '3':
            this.statusTxt = '已发卡'
            break;
          case '4':
            this.statusTxt = '已激活'
            break;
          case '5':
            this.statusTxt = '已实名'
            break;
          case '9':
            this.statusTxt = '被驳回'
            break;
          case '10':
            this.statusTxt = '已取消'
            break;
          default:
            break;
        }
      },
		},
	}
</script>
<style scoped>
  .title{
    font-weight: bold;
    text-align: center;
    padding: 15px 0;
    text-align: center;
    background: #fff;
    margin-bottom: 10px;
  }
</style>